import { render, staticRenderFns } from "./IFPdfRatios.vue?vue&type=template&id=192ae7e8"
import script from "./IFPdfRatios.vue?vue&type=script&lang=js"
export * from "./IFPdfRatios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports